<app-single-detail svgIcon="feather:hash" label="ID" [value]="outbountTransitUnitSummaryModel?.id"></app-single-detail>
<app-single-detail
  svgIcon="feather:truck"
  label="Courier name"
  [value]="outbountTransitUnitSummaryModel?.courierName"></app-single-detail>
<app-single-detail
  svgIcon="feather:truck"
  label="Courier tracking number"
  [value]="outbountTransitUnitSummaryModel?.courierTrackingNumber"></app-single-detail>
<app-single-detail
  svgIcon="feather:hash"
  label="Outbound ID"
  [value]="outbountTransitUnitSummaryModel?.outboundId"></app-single-detail>
